import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { HubDBIcon } from 'foundations-assets/icons/components/HubDBIcon';
import { LayersIcon } from 'foundations-assets/icons/components/LayersIcon';
import { QuestionAnswerIcon } from 'foundations-assets/icons/components/QuestionAnswerIcon';
import { WorkflowsIcon } from 'foundations-assets/icons/components/WorkflowsIcon';
export const HUB_TYPE_ICONS = {
  'marketing-hub': CampaignsIcon,
  'sales-hub': WorkflowsIcon,
  'service-hub': QuestionAnswerIcon,
  'commerce-hub': WorkflowsIcon,
  'cms-hub': LayersIcon,
  'content-hub': LayersIcon,
  'operations-hub': HubDBIcon,
  'marketing-plus': [LayersIcon, CampaignsIcon]
};
const getHubTypeFromApiName = apiName => {
  for (const hubType in HUB_TYPE_ICONS) {
    if (apiName.includes(hubType)) {
      return hubType;
    }
  }
  return null;
};
export const getIconForBullet = (apiName, bulletIndex = 0) => {
  const hubType = getHubTypeFromApiName(apiName);
  if (!hubType) {
    return LayersIcon;
  }
  const iconValue = HUB_TYPE_ICONS[hubType];
  if (Array.isArray(iconValue)) {
    return iconValue[bulletIndex] || iconValue[0];
  }
  return iconValue;
};